import { createRouter, createWebHistory } from "vue-router";
import LayoutPadraoo from "../components/layouts/LayoutPadrao.vue";
import { auth } from "../firebase";
import AcessoService from "../service/AcessoService";
import DoisFatoresService from "../service/DoisFatoresService";
import { temPermissao, PERMISSOES } from "../util/permissoes";

const routesPadrao = [
  {
    path: "",
    name: "cadastroAssociado",
    meta: { requiresAuth: true },
    component: LayoutPadraoo,
    children: [
      {
        path: "/home",
        name: "TelaInicial",
        component: () => import("../views/login/TelaInicial.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/cadastro-pessoa/:id?",
        name: "CadastroUsuarioInterno",
        component: () => import("../views/usuario/CadastroUsuarioInterno.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.CADASTRAR_LISTA_PESSOAS },
      },
      {
        path: "/sorteador",
        name: "SorteadorCorrupto",
        component: () => import("../views/calendario/SorteadorCorrupto.vue"),
      },

      {
        path: "/cadastro-medicamento/:id?",
        name: "MedicamentoCadastro",
        component: () => import("../views/medicamento/MedicamentoCadastro.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.CADASTRAR_MEDICAMENTOS },
      },
      {
        path: "/catalogo-medicamentos",
        name: "MedicamentoCatalogoGestao",
        component: () => import("../views/medicamento/MedicamentoCatalogoGestao.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.VISUALIZAR_CATALOGO_MEDICAMENTOS },
      },
      {
        path: "/pagamento/:id?",
        name: "PagamentoUsuario",
        component: () => import("../views/pagamento/PagamentoUsuario.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.VISUALIZAR_PAGAMENTOS },
      },
      {
        path: "/financeiro",
        name: "FinanceiroMensal",
        component: () => import("../views/financeiro/FinanceiroMensal.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.VISUALIZAR_FINANCEIRO },
      },
      {
        path: "/financeiro-categorias",
        name: "CategoriasFinanceiras",
        component: () => import("../views/financeiro/CategoriasFinanceiras.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.VISUALIZAR_FINANCEIRO },
      },
      {
        path: "/financeiro-recorrentes",
        name: "ContasRecorrentes",
        component: () => import("../views/financeiro/ContasRecorrentes.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.VISUALIZAR_FINANCEIRO },
      },
      {
        path: "/cadastro-usuario/:id?",
        name: "CadastroUsuario",
        component: () => import("../views/usuario/CadastroUsuarioInterno.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.CADASTRAR_LISTA_PESSOAS },
      },
      {
        path: "/unificar-usuario",
        name: "UnificarUsuario",
        component: () => import("../views/usuario/UsuarioDuplicado.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.EDITAR_LISTA_PESSOAS },
      },
      {
        path: "/gerenciar-menus",
        name: "GerenciarMenus",
        component: () => import("../views/usuario/GerenciarMenus.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.VISUALIZAR_MENUS },
      },
      {
        path: "/gerenciar-permissoes",
        name: "GerenciarPermissoes",
        component: () => import("../views/usuario/GerenciarPermissoes.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.VISUALIZAR_GRUPOS_ACESSO },
      },
      {
        path: "/listar-pessoa/:id?",
        name: "ListarUsuario",
        component: () => import("../views/usuario/ListarUsuario.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.VISUALIZAR_LISTA_PESSOAS },
      },
      {
        path: "/listar-medicamento/:id?",
        name: "ListarMedicamento",
        component: () => import("../views/medicamento/ListarMedicamento.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.VISUALIZAR_MEDICAMENTOS },
      },
      {
        path: "/calendario",
        name: "AgendaCalendario",
        component: () => import("../views/calendario/CalendarioView.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/seminario",
        name: "Quarto",
        component: () => import("../views/casa/Quarto.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.VISUALIZAR_GESTAO_QUARTOS },
      },
      {
        path: "/eventos",
        name: "GerenciarEventos",
        component: () => import("../views/eventos/GerenciarEventos.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.VISUALIZAR_EVENTOS },
      },
      {
        path: "/auditoria",
        name: "Auditoria",
        component: () => import("../views/auditoria/Auditoria.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.VISUALIZAR_AUDITORIA },
      },
      {
        path: "/listar-inscritos-retiro",
        name: "ListarInscritosRetiro",
        component: () => import("../views/casa/ListarInscritosRetiro.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.VISUALIZAR_INSCRITOS_RETIRO },
      },
      {
        path: "/fichas-retiro",
        name: "FichasRetiro",
        component: () => import("../views/casa/FichasRetiro.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.VISUALIZAR_INSCRITOS_RETIRO },
      },
      {
        path: "/fila-atendimentos",
        name: "GerenciarFila",
        component: () => import("../views/Fila/GerenciarFila.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.VISUALIZAR_FILA },
      },
      {
        path: "/painel-fila",
        name: "PainelFila",
        component: () => import("../views/Fila/PainelFila.vue"),
        meta: { requiresAuth: true, permission: PERMISSOES.VISUALIZAR_PAINEL_FILA },
      },
      {
        path: "/programacao",
        name: "TelaProgramacao",
        component: () => import("../views/live/TelaProgramacao.vue"),
        meta: { requiresAuth: true },
      },
    ],
  },
];
const routesSemFundo = [
  {
    path: "/login",
    name: "telaLogin",
    children: [
      {
        path: "/login",
        name: "LoginUsuario",
        component: () => import("../views/login/TelaLogin.vue"),
      },
      {
        path: "/2fa",
        name: "DoisFatores",
        component: () => import("../views/login/TelaDoisFatores.vue"),
      },
      {
        // Sem slug, abre o evento ativo; com slug, o evento indicado.
        path: "/inscricao-retiro/:slug?",
        name: "InscricaoRetiro",
        component: () => import("../views/casa/InscricaoRetiro.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/inscricao-retiro-equipe-trabalho/:slug?",
        name: "InscricaoRetiroEquipeTrabalho",
        component: () => import("../views/casa/InscricaoRetiroEquipeTrabalho.vue"),
        meta: { requiresAuth: false },  
      },
      {
        // Sem slug, abre a live do evento ativo; com slug, a do evento indicado.
        // "/xreaja" continua valendo para os links já divulgados.
        path: "/ao-vivo/:slug?",
        alias: ["/xreaja"],
        name: "TelaAoVivo",
        component: () => import("../views/live/TelaAoVivo.vue"),
        meta: { requiresAuth: false },
      },
    ],
  },
];

const routes = routesPadrao.concat(routesSemFundo);

const router = createRouter({
  history: createWebHistory("/aom-web-admin"),
  routes,
});

const PERMISSIONS_STORAGE_KEY = "userPermissions";

const obterUsuarioAtual = () =>
  new Promise((resolve) => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      unsubscribe();
      resolve(user);
    });
  });

const carregarPermissoesSeNecessario = async () => {
  const salvas = localStorage.getItem(PERMISSIONS_STORAGE_KEY);
  if (salvas) {
    return JSON.parse(salvas);
  }

  const { data } = await AcessoService.buscarMeuAcesso();
  // permissoesEfetivas = grupos + avulsas. O campo "permissoes" traz so as avulsas.
  const permissoes = data?.usuario?.permissoesEfetivas || data?.usuario?.permissoes || [];
  localStorage.setItem(PERMISSIONS_STORAGE_KEY, JSON.stringify(permissoes));
  return permissoes;
};

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const requiredPermission = to.matched.find((record) => record.meta?.permission)?.meta?.permission;

  if (requiresAuth) {
    const user = await obterUsuarioAtual();

    if (!user) {
      next("/login");
      return;
    }

    // Sem sessão do segundo fator ativa → volta ao login. A tela de 2FA só é
    // alcançada como passo logo após digitar a senha (evita cair no 2FA à toa
    // por causa de uma sessão do Firebase que ficou persistida).
    if (!DoisFatoresService.temSessao()) {
      next("/login");
      return;
    }

    if (to.path !== "/login") {
      localStorage.setItem("lastRoute", to.fullPath);
    }

    if (requiredPermission) {
      try {
        const permissoes = await carregarPermissoesSeNecessario();
        if (!temPermissao(permissoes, requiredPermission)) {
          next("/home");
          return;
        }
      } catch (error) {
        localStorage.removeItem(PERMISSIONS_STORAGE_KEY);
        next("/home");
        return;
      }
    }

    next();
  } else {
    next();
  }
});

export default router;
